const LIVE = "LIVE";
const UPCOMING = "UPCOMING";

export { LIVE, UPCOMING };
